import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { toODataString } from '@progress/kendo-data-query';
import { list, XLS } from '@hobs/constants/odata';
import { getNotifications } from './notifications';

export function formatFilter(quickSearch) {
  return {
    logic: 'and',
    filters: [
      {
        field: 'QuickSearchField',
        operator: 'contains',
        value: quickSearch
      }
    ]
  };
}

export function tryGetODataString(params) {
  try {
    return toODataString(params);
  } catch (e) {
    return '';
  }
}

function oDataFetch(path, params) {
  if (params.quickSearch) {
    params = { ...params, filter: formatFilter(params.quickSearch) };
  }
  
  let oDataParams = tryGetODataString(params);

  // add '+02:00' timezone to dates to also include selected date (default is 00:00)
  oDataParams = addTimeZoneOffsetToDate(oDataParams);

  // Replaces '<guid> and </guid>' to allow to use guid
  const regExp = /('%3Cguid%3E)|(%3C%2Fguid%3E')/g;
  oDataParams = oDataParams.replace(regExp, '');

  return fetchSecure(`${path}?$count=true&${oDataParams}`, { cancel: true });
}

function addTimeZoneOffsetToDate(dateString) {
  // Check if the string contains a date in the expected format
  const dateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/g;
  const matches = dateString.match(dateRegex);
  if (!matches) {
      return dateString;
  }
  
  // Add timezone offset to each date
  const modifiedString = dateString.replace(dateRegex, (match) => {
      if (match) {
          const encodedPlusSymbol = '%2b'
          return match.replace("Z", `${encodedPlusSymbol}02:00`);
      }
      return match;
  });
  
  return modifiedString;
}

export function queryOData(path, params = { take: 10, skip: 0 }) {
  return dispatch => {
    dispatch(request());

    return oDataFetch(path, params)
      .then(response => {
        dispatch(
          success({
            data: response.payload.value,
            total: response.payload['@odata.count']
          })
        );

        if (path === 'AnnexServiceRequestQuery' || path === 'ServiceRequestQuery') {
          return dispatch(getNotifications({ ...params, skip: 0, take: 0 }));
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: list.REQUEST };
  }
  function success(payload) {
    return { type: list.SUCCESS, payload };
  }
  function failure(error) {
    return { type: list.FAILURE, error };
  }
}

export function queryXLSOData(path, params = {}) {
  return dispatch => {
    dispatch(request());

    return oDataFetch(path, params)
      .then(response => {
        dispatch(
          success({
            data: response.payload.value,
            total: response.payload['@odata.count']
          })
        );

        return {
          data: response.payload.value,
          total: response.payload['@odata.count']
        };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: XLS.REQUEST };
  }
  function success(payload) {
    return { type: XLS.SUCCESS, payload };
  }
  function failure(error) {
    return { type: XLS.FAILURE, error };
  }
}

export function resetOData() {
  return {
    type: list.RESET
  };
}
